import isEmpty from 'lodash/isEmpty';
import Utils from './utils';

const resendableServerLogsKey = 'resendable-server-logs';
const resendableServerLogsTtl = 300000; // 5m in milliseconds

function _isNil(obj) {
  return typeof obj === 'undefined' || obj === null;
}

function setServerLog(log) {
  if (Utils.isServerSide()) {
    return;
  }
  if (!_isNil(log) && !isEmpty(log)) {
    let existingItem = { value: [] };

    const existingItemStr = localStorage.getItem(resendableServerLogsKey);
    if (!_isNil(existingItemStr)) {
      existingItem = JSON.parse(existingItemStr);
    }

    existingItem.value.push(log);

    const item = {
      value: existingItem.value,
      expiry: (new Date()).getTime() + resendableServerLogsTtl
    };
    localStorage.setItem(resendableServerLogsKey, JSON.stringify(item));
  }
}

function getServerLog() {
  if (Utils.isServerSide()) {
    return null;
  }
  const itemStr = localStorage.getItem(resendableServerLogsKey);
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);

  if ((new Date()).getTime() > item.expiry || item.value.length === 0) {
    localStorage.removeItem(resendableServerLogsKey);
    return null;
  }

  const log = item.value[0];
  item.value.splice(0, 1);

  if (item.value.length === 0) {
    localStorage.removeItem(resendableServerLogsKey);
  } else {
    localStorage.setItem(resendableServerLogsKey, JSON.stringify(item));
  }

  return log;
}

export {
  setServerLog,
  getServerLog
};
